import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config';
import './PartnersSection.css';

const PartnersSection = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/partners`)
      .then(res => res.json())
      .then(data => setPartners(data))
      .catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="partners-header">
          <span className="partners-subtitle">İş Ortaklarımız</span>
          <h2 className="partners-title">Birlikte Çalıştığımız Markalar</h2>
          <p className="partners-desc">
            Tesislerimizde hizmet kalitemizi artırmak için güçlü markalarla iş birliği yapıyoruz.
          </p>
        </div>

        <div className="partners-track-wrapper">
          <div className="partners-track">
            {[...partners, ...partners].map((partner, index) => (
              <div className="partner-item" key={index}>
                <div className="partner-logo">
                  {partner.logo ? (
                    <img src={partner.logo} alt={partner.name} />
                  ) : (
                    <span>{partner.initial}</span>
                  )}
                </div>
                <span className="partner-name">{partner.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
